import { useContentActions } from "../../../hooks/ContentActionsContext";
import ThemedSpinner from "../spinner";
import { ImageActionButtons } from "./image-action-buttons";

export const RenderImageInMarkdown = ({
  src,
  alt,
  isInTable,
}: {
  src: string;
  alt: string;
  isInTable: boolean;
}) => {
  const { imageUrlUpdating } = useContentActions();

  return (
    <div>
      {imageUrlUpdating === src ? (
        <ThemedSpinner size="lg" />
      ) : (
        <>
          <img
            src={src}
            alt={alt}
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              borderRadius: "8px",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              margin: isInTable ? "0" : "1rem 0",
            }}
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <ImageActionButtons src={src ?? null} />
        </>
      )}
    </div>
  );
};
